import { TaskCardSkeleton } from "../../../tasks/components/TaskCard/TaskCardSkeleton";
import styles from "./activity-column.module.css";

interface MobileColumnSkeletonProps {
  activeTab: string;
  tab: string;
}

export const MobileColumnSkeleton = ({
  activeTab,
  tab,
}: MobileColumnSkeletonProps) => {
  return (
    <div
      className={`${styles["skeleton"]} ${activeTab === tab && styles["active"]}`}
    >
      <TaskCardSkeleton />
      <TaskCardSkeleton />
      <TaskCardSkeleton />
      <TaskCardSkeleton />
    </div>
  );
};
